<div class="center">
  <div class="circle-wrapper" 
       (click)="onAvatarClick()"
       (contextmenu)="resimSil();"
       [style.width]="size() ? size().toString() + 'px': '128px'"
       [style.height]="size() ? size().toString() + 'px': '128px'">
    <div class="circle-avatar outer" nz-wave z-index="0"
         [style.background-color]="'#1976D2'"
         [style.width]="size() ? size().toString() + 'px': '128px'"
         [style.height]="size() ? size().toString() + 'px': '128px'"
         [style.background-color]="borderColor()"></div>

    <div class="circle-avatar inner" nz-wave z-index="0"
         [style.background-color]="backgroundColor()"
         [style.width]="(size() - borderSize()).toString() + 'px'"
         [style.height]="(size() - borderSize()).toString() + 'px'"
         [style.top]="(borderSize() / 2 ).toString() + 'px'"
         [style.left]="(borderSize() / 2 ).toString() + 'px'">
      @if (image()) {
      <img [src]="image()"
           alt="Profile"
           class="avatar-image"
           [@imageChange]="isImageVisible() ? 'visible' : 'hidden'" />
      } @else {
      <div class="avatar-icon"
           [@imageChange]="!isImageVisible() ? 'visible' : 'hidden'">
        👨‍💼
      </div>
      }
    </div>
  </div>
</div>